// Feature flag 'lock-long-standing-delinquents' removed - was always FALSE in production
// Delinquent locking logic removed as feature was never enabled
export default () => {
  // No-op: feature flag was always false in production
};
